import { render, staticRenderFns } from "./Lots.vue?vue&type=template&id=5c5e83bb&"
import script from "./Lots.vue?vue&type=script&lang=ts&"
export * from "./Lots.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports